<template>
  <section class="quizzes-item-now row pb-3 pt-3">
    <div class="col">
      <div class="card">
        <div
          class="card-header"
          :style="currentQuiz && currentQuiz.status && (currentQuiz.status === 'sent' || currentQuiz.status === 'ready') ?
        'background-color:white': 'background-color:yellowgreen'">
          <div class="row">
            <h3 class="h2 ml-3">{{ curTitle }}</h3>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-9">
              {{ curCustomValue }}
              <b-list-group-item
                v-for="s in curSelections"
                :key="curSelections.indexOf(s)"
                class="font-weight-bold">
                {{ s }}
                <span
                  v-if="curQuizAnswer === curSelections.indexOf(s)"
                  class="badge badge-secondary">
                  정답
                </span>
              </b-list-group-item>
            </div>
            <div class="col">
              <b-list-group-item class="font-weight-bold">
                {{ currentAnswerForUid('s0') }} ({{ selectRatio(currentAnswerForUid('s0')) }} %)
              </b-list-group-item>
              <b-list-group-item class="font-weight-bold">
                {{ currentAnswerForUid('s1') }} ({{ selectRatio(currentAnswerForUid('s1')) }} %)
              </b-list-group-item>
              <b-list-group-item class="font-weight-bold">
                {{ currentAnswerForUid('s2') }} ({{ selectRatio(currentAnswerForUid('s2')) }} %)
              </b-list-group-item>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
// import * as _ from 'ramda'
// import l from '@/vendor/logger'

// let timer

export default {
  name: 'QuizzesItemNow',

  created () {
    this.$store.dispatch('quizzes/bindCurrentAnswerForUid')
    if (!this.isBeforeSelectQuizzes && this.isBefore1stQuiz) {
      this.curQuizOrder = 0
      this.nextQuiz = this.quizOfToday.quizs[0]
    }
  },

  props: {
  },

  data () {
    return {
      order: null,
      submitted: false,
      rightAnswer: 0,
      selectCount: { s0: 0, s1: 0, s2: 0 },
      remainTime: 0
    }
  },

  watch: {
    numberOfSelect () {
      if (this.currentQuiz) {
        const numberOfSelect = this.numberOfSelect['.value']
        if (numberOfSelect && numberOfSelect.length > 0) {
          numberOfSelect.forEach(v => {
            if (this.currentQuiz.refIndex === v.refIndex) {
              this.selectCount = v
              this.rightAnswer = this.selectCount[`s${this.currentQuiz.answer}`]
            }
          })
        }
      }
    },
    currentQuiz () {
      this.remainTime = this.room.quizTimeLimit
    }
  },
  methods: {
    selectRatio (select) {
      if (this.isBeforeSelectQuizzes || this.isBefore1stQuiz || !this.room.totalParticipants) return '.'
      if (select === 0 || this.latestTotalParticipants === 0) return 0
      return Math.round(select / this.latestTotalParticipants * 100)
      // return Math.round(select / (this.currentAnswerForUid('s0') + this.currentAnswerForUid('s1') + this.currentAnswerForUid('s2')) * 100)
    }
  },

  computed: {
    ...mapState('quizzes', [
      'quizOfToday',
      'quizHistory'
    ]),
    ...mapState('quizzes', [
      'numberOfRight',
      'numberOfSelect'
    ]),
    ...mapGetters('quizzes', [
      'currentQuiz',
      'isBeforeSelectQuizzes',
      'isBefore1stQuiz',
      'isBefore1stQuizSendAnswer',
      'currentAnswerForUid',
      'latestTotalParticipants'
    ]),
    ...mapState('room', [
      'room'
    ]),
    curTitle () {
      if (this.isBeforeSelectQuizzes || this.isBefore1stQuiz) return '문제가 시작전입니다'
      // if (this.isBefore1stQuiz) return `문제 1 :${this.quizOfToday.quizs[0].question}`

      return this.currentQuiz.type === 'quiz'
        ? `문제 ${this.currentQuiz.index + 1} : ${this.currentQuiz.question}`
        : `공지 ${this.currentQuiz.title}: `
    },
    curSelections () {
      if (this.isBeforeSelectQuizzes) return ['.', '..', '...']
      // if (this.isBefore1stQuiz) return `문제 1 :${this.quizOfToday.quizs[0].selection}`

      return this.currentQuiz.selection
    },
    curCustomValue () {
      if (this.isBeforeSelectQuizzes || this.isBefore1stQuiz) return ''
      return this.currentQuiz.type === 'quiz' ? '' : this.currentQuiz.value
    },
    curQuizAnswer () {
      if (this.currentQuiz && this.currentQuiz.answer !== undefined) {
        return this.currentQuiz.answer
      }
    }
  },

  components: {
  }
}
</script>

<style scoped>
.quizzes-item-now {
  & .card-body {
    padding: .5rem;
    & .list-group-item {
      font-size: 1.5rem;
      padding: .3rem 1rem;
    }
  }
}
</style>
